//@ts-check
// @ts-ignore
import App from './app.riot';
import { closeDialog } from '@/common/components/kf-dialog';
import { connect } from '@/common/lib/riot-redux';

const mapStateToProps = (state) => {
  return {
    loader: state.loader,
    dialog: state.dialog,
    shopId: state.app.shopId,
    web: state.app.web,
    valid: state.app.valid,
    up: state.app.up,
    errMsgLogin: state.app.errMsgLogin,
    errMsgPassword: state.app.errMsgPassword,
    
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeDialog() {
    dispatch(closeDialog());
  },
});

export default connect(App, mapStateToProps, mapDispatchToProps);